import { Backdrop, CircularProgress } from "@mui/material"

const PageLoader = ({
  show
}) => {
  return(
    <Backdrop
      open = {show}
      sx={{
        zIndex : '2100',
        color : '#fff'
      }}
    >
      <CircularProgress
        color="inherit"
        size="100px"
      />
    </Backdrop>
  )
}

export default PageLoader;